import tokens from '@frete.com/fuel-tokens/theme.json';

type ColorMode = { light: string; dark: string };

const light = (color: ColorMode) => color.light;

const literals = {
  surface: {
    primary: light(tokens.semantic.color.surface.primary),
    default: light(tokens.semantic.color.surface.default),
  },
  text: {
    strong: light(tokens.semantic.color.text.strong),
  },
  icon: {
    success: light(tokens.semantic.color.icon.success),
    danger: light(tokens.semantic.color.icon.danger),
    inverted: light(tokens.semantic.color.icon.inverted),
  },
};

export default literals;
